import React, { PureComponent } from "react";
import Grid from "@material-ui/core/Grid";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Button from "@material-ui/core/Button";
import VerticalSpace from "./components/VerticalSpace";
import { reduxForm } from "redux-form";
import CurrencyUsdIcon from "mdi-react/CurrencyUsdIcon";
import { Route } from "react-router-dom";
import AppConfig from "../../config/appconfig.json";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import $ from "jquery";
import KBELogo from "../account/img/kbe-Logo-66454.png";

class BookAppointment extends PureComponent {
  constructor(props) {
    super(props);
    const system = this.props.location.state
      ? this.props.location.state.airconsystem
      : null;
    // console.log(system);
    this.state = {
      systemOptions: [],
      systemList: system ? [system] : [],
      startDate: moment(),
      currDatePickerMonth: moment().month() + 1,
      airconsystem: system,
      systemid: system ? system.Sid : "",
      clientid: system ? system.Client : "",
      selectedslot: "",
      postalcode: system ? system.PostalCode : "",
      availableDates: [],
      includeDates: [],
      includeTimes: [],
      type1: "",
      type2: "",
      type3: "",
      fancoils1: "",
      fancoils2: "",
      fancoils3: "",
      // servicingPriceSid1: "",
      // servicingPriceSid2: "",
      // servicingPriceSid3: "",
      servicePricingOptions: [],
      typeoptions: [],
      fancoils1options: [],
      fancoils2options: [],
      fancoils3options: [],
      amount1: 0,
      amount2: 0,
      amount3: 0,
      totalamount: 0,
      showErrorAmount: false,
      showErrorSlot: false,
      showErrorSystemId: false,
      page: 1,
      selectedCustomerType: system ? system.CustomerType : ""
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleAirconChange = this.handleAirconChange.bind(this);
    this.retrieveCustomerSystem = this.retrieveCustomerSystem.bind(this);
    this.getApptSlot = this.getApptSlot.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleType1Change = this.handleType1Change.bind(this);
    this.handleType2Change = this.handleType2Change.bind(this);
    this.handleType3Change = this.handleType3Change.bind(this);
    this.handleFancoils1Change = this.handleFancoils1Change.bind(this);
    this.handleFancoils2Change = this.handleFancoils2Change.bind(this);
    this.handleFancoils3Change = this.handleFancoils3Change.bind(this);
    this.getServicePricing = this.getServicePricing.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.disableVirtualKeyboard = this.disableVirtualKeyboard.bind(this);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 });
    this.disableVirtualKeyboard();
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
    this.disableVirtualKeyboard();
  }

  handleSubmit(event) {
    // if (parseFloat(this.state.totalamount) === 0)
    //   this.setState({ showErrorAmount: true });
    event.preventDefault();
    // console.log("form submitted");
  }

  handleDateChange(date) {
    this.setState({ startDate: date, currDatePickerMonth: date.month() + 1 });
    this.updateTimingBasedOnSelectedDate(date);
  }

  updateTimingBasedOnSelectedDate(date) {
    // find available times
    const sameDate = this.state.availableDates.filter(
      e => moment(e.dates, "DD/MM/YYYY").diff(date, "days") === 0
    );
    if (sameDate.length > 0) {
      if (sameDate[0].timing) {
        let timeList = [];
        sameDate[0].timing.forEach(elm => {
          timeList.push({ value: elm, label: elm });
        });
        this.setState({ includeTimes: timeList });
        // console.log(timeList);
      }
    }
  }

  handleTimeChange(e) {
    this.setState({ selectedslot: e.value, showErrorSlot: false });
  }

  handleMonthChange(newDate) {
    // console.log(moment(newDate._d).month()+1);
    const newMonth = moment(newDate._d).month() + 1;
    // const currMonth = moment().month() + 1;
    // console.log(newMonth);
    // console.log(currMonth);
    // if (newMonth >= currMonth) {
    this.setState({ currDatePickerMonth: newMonth });
    // console.log(this.state.currDatePickerMonth);
    this.getApptSlot(this.state.postalcode, newMonth);
    // }
  }

  handleAirconChange(e) {
    if (e) {
      this.setState({ systemid: e.value, showErrorSystemId: false });
      // Find postal code of the selected aircon
      // console.log(this.state.systemList);
      // console.log(e.value);
      const selectedSystem = this.state.systemList.filter(
        (elm, i) => elm.Sid === e.value
      );
      // console.log(selectedSystem);
      if (selectedSystem) {
        if (selectedSystem.length > 0) {
          // console.log(selectedSystem[0].PostalCode);
          this.setState({
            postalcode: selectedSystem[0].PostalCode,
            clientid: selectedSystem[0].Client,
            selectedCustomerType: selectedSystem[0].CustomerType
          });
          this.getApptSlot(
            selectedSystem[0].PostalCode,
            this.state.currDatePickerMonth
          );
        }
      }
    }
  }

  getAvailableUnits(serviceCategory) {
    const availableUnits = this.state.servicePricingOptions.filter(
      p => p.ServiceCategory === serviceCategory
    );
    let unitOptions = [];
    availableUnits.sort((a, b) => a.ServiceUnit - b.ServiceUnit);
    availableUnits.forEach(p => {
      unitOptions.push({
        value: p.Sid,
        label: p.ServiceUnit + " - $" + p.ServiceOneTimePrice
      });
    });
    // unitOptions.sort((a, b) => a.label > b.label);
    // console.log(unitOptions);
    return unitOptions;
  }

  handleType1Change(e) {
    const unitOptions = this.getAvailableUnits(e.value);
    this.setState({ type1: e.value, fancoils1options: unitOptions });
    // console.log(unitOptions);
  }

  handleType2Change(e) {
    const unitOptions = this.getAvailableUnits(e.value);
    this.setState({ type2: e.value, fancoils2options: unitOptions });
  }

  handleType3Change(e) {
    const unitOptions = this.getAvailableUnits(e.value);
    this.setState({ type3: e.value, fancoils3options: unitOptions });
  }

  getNewPrice(serviceCategory, servicePricingSid) {
    let newPrice = 0;
    const servicePricing = this.state.servicePricingOptions.filter(
      p => p.ServiceCategory === serviceCategory && p.Sid === servicePricingSid
    );
    if (servicePricing.length === 1) {
      newPrice = parseFloat(servicePricing[0].ServiceOneTimePrice);
    }
    return newPrice;
  }

  handleFancoils1Change(e) {
    const newAmount1 = this.getNewPrice(this.state.type1, e.value);
    const newTotalAmount = parseFloat(
      newAmount1 + this.state.amount2 + this.state.amount3
    ).toFixed(2);
    this.setState({
      fancoils1: e.value,
      amount1: newAmount1,
      totalamount: newTotalAmount,
      showErrorAmount: false
    });
  }

  handleFancoils2Change(e) {
    const newAmount2 = this.getNewPrice(this.state.type2, e.value);
    const newTotalAmount = parseFloat(
      this.state.amount1 + newAmount2 + this.state.amount3
    ).toFixed(2);
    this.setState({
      fancoils2: e.value,
      amount2: newAmount2,
      totalamount: newTotalAmount,
      showErrorAmount: false
    });
  }

  handleFancoils3Change(e) {
    const newAmount3 = this.getNewPrice(this.state.type3, e.value);
    const newTotalAmount = parseFloat(
      this.state.amount1 + this.state.amount2 + newAmount3
    ).toFixed(2);
    this.setState({
      fancoils3: e.value,
      amount3: newAmount3,
      totalamount: newTotalAmount,
      showErrorAmount: false
    });
  }

  componentDidMount() {
    this.retrieveCustomerSystem();
    this.getApptSlot(this.state.postalcode, this.state.currDatePickerMonth);
    this.getServicePricing();

    // Disable virtual keyboard
    this.disableVirtualKeyboard();
  }

  disableVirtualKeyboard() {
    $(document).ready(function () {
      if (window.Modernizr.touch) {
        // Disable keyboard by adding readonly attribute to field
        $('.data-disable-touch-keyboard').attr('readonly', 'readonly');
        $('input[role="combobox"]').attr('readonly', 'readonly');
      }
    });
  }

  retrieveCustomerSystem() {
    if (this.state.airconsystem) {
      const systemDescr =
        this.state.airconsystem.Brand +
        " " +
        this.state.airconsystem.Type +
        " " +
        this.state.airconsystem.Model +
        " (" +
        this.state.airconsystem.PostalCode +
        ")";
      this.setState({
        systemOptions: [
          { value: this.state.airconsystem.Sid, label: systemDescr }
        ]
      });
    } else {
      const kbeSid = localStorage.getItem("kbeSid");
      if (kbeSid) {
        let isretrieveCustomerSystemFailed = false;
        // Call Back-End Services
        fetch(
          `${AppConfig.BACK_END_URL}/APIClient/RetrieveCustomerSystem?Sid=` +
          kbeSid
        )
          .then(response => {
            // console.log(response);
            if (response.ok === false) {
              isretrieveCustomerSystemFailed = true;
            }
            return response.json();
          })
          .then(json => {
            if (isretrieveCustomerSystemFailed) {
            } else {
              const respObj = JSON.parse(json);
              // console.log(respObj);
              // if (respObj.length === 1) {
              //   if (respObj[0].Type === "") {
              //     window.location = "/register_aircon";
              //     return;
              //   }
              // }
              const cmbSystemList = [];
              let i = 0;
              for (i = 0; i < respObj.length; i++) {
                const system = respObj[i];
                const systemDescr =
                  system.Brand +
                  " " +
                  system.Type +
                  " " +
                  system.Model +
                  " (" +
                  system.PostalCode +
                  ")";
                cmbSystemList.push({
                  value: system.Sid,
                  label: systemDescr
                });
              }
              this.setState({
                systemOptions: cmbSystemList,
                systemList: respObj
              });
            }
          })
          .catch(() => {
            console.log(
              "Something went wrong when retrieving customer systems. Please try again."
            );
            window.location = "/";
          });
      }
    }
  }

  getApptSlot(postalcode, month) {
    if (postalcode === "") {
      return;
    }
    let isGetApptSlotFailed = false;
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        postalcode: postalcode,
        month: month.toString()
      })
    };
    // Call Back-End Services
    fetch(`${AppConfig.BACK_END_URL}/APIAppt/GetAppSlot`, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          isGetApptSlotFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isGetApptSlotFailed) {
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          if (respObj) {
            // only show today's date and the future
            const filteredDates = respObj.filter(e =>
              moment(e.dates, "DD/MM/YYYY").isAfter(moment().add(-1, "days"))
            );
            // console.log(filteredDates);
            this.setState({ availableDates: filteredDates });
            let list = [];
            for (let i = 0; i < filteredDates.length; i++) {
              const date = moment(filteredDates[i].dates, "DD/MM/YYYY");
              if (i === 0) {
                this.setState({
                  startDate: date,
                  currDatePickerMonth: date.month() + 1
                });
                this.updateTimingBasedOnSelectedDate(date);
              }
              list.push(date);
            }
            // console.log(filteredDates);
            this.setState({ includeDates: list });
          }
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when retrieving appointment slot. Please try again."
        );
      });
  }

  getServicePricing() {
    let isServicePricingFailed = false;

    fetch(`${AppConfig.BACK_END_URL}/APIAppt/GetServicePricing`)
      .then(response => {
        if (response.ok === false) {
          isServicePricingFailed = true;
        }
        return response.json();
      })
      .then(json => {
        if (isServicePricingFailed) {
        } else {
          const respObj = JSON.parse(json);
          // console.log(respObj);
          if (respObj) {
            let uniqueServices = [];
            for (let i = 0; i < respObj.length; i++) {
              let svc = respObj[i];
              if (
                !uniqueServices.some(item => item.value === svc.ServiceCategory)
              ) {
                uniqueServices.push({
                  value: svc.ServiceCategory,
                  label: svc.ServiceCategory
                });
              }
            }
            // console.log(uniqueServices);
            this.setState({
              typeoptions: uniqueServices,
              servicePricingOptions: respObj
            });
          }
        }
      })
      .catch(() => {
        console.log(
          "Something went wrong when retrieving service pricing. Please try again."
        );
      });
  }

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }

  render() {
    const PaymentButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              type="submit"
              style={{ width: "100%" }}
              onClick={() => {
                // validation
                if (this.state.systemid === "") {
                  this.setState({ showErrorSystemId: true, page: 1 });
                  this.disableVirtualKeyboard();
                  return;
                }
                if (this.state.selectedslot === "") {
                  this.setState({ showErrorSlot: true, page: 1 });
                  this.disableVirtualKeyboard();
                  return;
                }
                if (this.state.totalamount <= 0) {
                  this.setState({ showErrorAmount: true, page: 1 });
                  this.disableVirtualKeyboard();
                  return;
                }
                // console.log(this.state.systemid);
                // console.log(this.state.clientid);
                let selectedServices = [];
                if (this.state.fancoils1 !== "") {
                  const svc = this.state.servicePricingOptions.filter(
                    p => p.Sid === this.state.fancoils1
                  );
                  // console.log(this.state.servicePricingOptions);
                  // console.log(this.state.fancoils1);
                  // console.log(svc);
                  // console.log(svc[0].ServiceUnit);
                  selectedServices.push({
                    ServicingPriceSid: this.state.fancoils1,
                    ServiceCategory: this.state.type1,
                    ServiceUnit: svc[0].ServiceUnit
                  });
                }
                if (this.state.fancoils2 !== "") {
                  const svc = this.state.servicePricingOptions.filter(
                    p => p.Sid === this.state.fancoils2
                  );
                  selectedServices.push({
                    ServicingPriceSid: this.state.fancoils2,
                    ServiceCategory: this.state.type2,
                    ServiceUnit: svc[0].ServiceUnit
                  });
                }
                if (this.state.fancoils3 !== "") {
                  const svc = this.state.servicePricingOptions.filter(
                    p => p.Sid === this.state.fancoils3
                  );
                  selectedServices.push({
                    ServicingPriceSid: this.state.fancoils3,
                    ServiceCategory: this.state.type3,
                    ServiceUnit: svc[0].ServiceUnit
                  });
                }
                const request = {
                  ClientSid: this.state.clientid,
                  SystemSid: this.state.systemid,
                  DateAppt: moment(this.state.startDate).format("DD/MM/YYYY"),
                  Slot: this.state.selectedslot,
                  Servicing: selectedServices,
                  Amount: this.state.totalamount,
                  CustomerType: this.state.selectedCustomerType
                };
                // console.log(request);
                // console.log(moment(this.state.startDate).format("DD/MM/YYYY"));
                history.push({
                  pathname: "/payment",
                  state: {
                    requestForm: request
                  }
                });
              }}
            >
              Payment
            </Button>
          </div>
        )}
      />
    );

    return (
      <div>
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Appointment</h4>
                </center>
                <br />
              </div>
              <form className="form form--horizontal" onSubmit={this.handleSubmit}>
                {this.state.page === 1 && <div id="form-step-1" className="form__form-group">
                  <div className="form__form-group">
                    <label className="form__form-group-label">System: </label>
                    <div className="form__form-group-field">
                      <Select
                        name="system"
                        value={this.state.systemid}
                        options={this.state.systemOptions}
                        onChange={this.handleAirconChange}
                        clearable={false}
                        className="form__form-group-select"
                        required={true}
                      />
                    </div>
                    {this.state.showErrorSystemId ? (
                      <div className="form__form-group-field">
                        <span className="list-text-red">
                          Please select a system
                      </span>
                      </div>
                    ) : (
                        <span />
                      )}
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Date: </label>
                    <div className="form__form-group-field">
                      <DatePicker
                        dateFormat="DD/MM/YYYY"
                        selected={this.state.startDate}
                        onChange={this.handleDateChange}
                        includeDates={this.state.includeDates}
                        forceShowMonthNavigation={true}
                        onMonthChange={this.handleMonthChange}
                        className="form__form-group-select data-disable-touch-keyboard"
                        onChangeRaw={this.handleDateChangeRaw}
                        disabledKeyboardNavigation={true}
                        readonly={true}
                        popperPlacement="top"
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Slot: </label>
                    <div className="form__form-group-field">
                      <Select
                        name="slot"
                        value={this.state.selectedslot}
                        options={this.state.includeTimes}
                        onChange={this.handleTimeChange}
                        clearable={false}
                        className="form__form-group-select"
                        required={true}
                      />
                    </div>
                    {this.state.showErrorSlot ? (
                      <div className="form__form-group-field">
                        <span className="list-text-red">
                          Please select a slot
                      </span>
                      </div>
                    ) : (
                        <span />
                      )}
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Type 1: </label>
                    <div className="form__form-group-field">
                      <Select
                        name="type1"
                        options={this.state.typeoptions}
                        placeholder="Select service type"
                        className="form__form-group-select"
                        value={this.state.type1}
                        onChange={this.handleType1Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Unit(s): </label>
                    <div className="form__form-group-field">
                      <Select
                        name="fancoils1"
                        placeholder="Select the number of unit(s)"
                        options={this.state.fancoils1options}
                        className="form__form-group-select"
                        value={this.state.fancoils1}
                        onChange={this.handleFancoils1Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                </div>
                }
                {this.state.page === 2 && <div id="form-step-2" className="form__form-group">
                  <div className="form__form-group">
                    <label className="form__form-group-label">Type 2: </label>
                    <div className="form__form-group-field">
                      <Select
                        name="type2"
                        options={this.state.typeoptions}
                        placeholder="Select service type"
                        className="form__form-group-select"
                        value={this.state.type2}
                        onChange={this.handleType2Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Unit(s): </label>
                    <div className="form__form-group-field">
                      <Select
                        name="fancoils2"
                        placeholder="Select the number of unit(s)"
                        options={this.state.fancoils2options}
                        className="form__form-group-select"
                        value={this.state.fancoils2}
                        onChange={this.handleFancoils2Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                </div>
                }
                {this.state.page === 3 && <div id="form-step-3" className="form__form-group">
                  <div className="form__form-group">
                    <label className="form__form-group-label">Type 3: </label>
                    <div className="form__form-group-field">
                      <Select
                        name="type3"
                        options={this.state.typeoptions}
                        placeholder="Select service type"
                        className="form__form-group-select"
                        value={this.state.type3}
                        onChange={this.handleType3Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <label className="form__form-group-label">Unit(s): </label>
                    <div className="form__form-group-field">
                      <Select
                        name="fancoils3"
                        placeholder="Select the number of unit(s)"
                        options={this.state.fancoils3options}
                        className="form__form-group-select"
                        value={this.state.fancoils3}
                        onChange={this.handleFancoils3Change}
                        clearable={false}
                      />
                    </div>
                  </div>
                </div>
                }
                <div className="form__form-group">
                  <label className="form__form-group-label">Amount</label>
                  <div className="form__form-group-field">
                    <div className="form__form-group-icon">
                      <CurrencyUsdIcon />
                    </div>
                    <input
                      name="amount"
                      type="text"
                      placeholder="Amount"
                      disabled={true}
                      value={this.state.totalamount}
                    />
                  </div>
                  {this.state.showErrorAmount ? (
                    <div className="form__form-group-field">
                      <span className="list-text-red">
                        Please select at least one service
                      </span>
                    </div>
                  ) : (
                      <span />
                    )}
                </div>
                {/* <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={3} />
                    <Grid item xs={6}>
                      <PaymentButton />
                      <Button
                        variant="outlined"
                        type="submit"
                        style={{ width: "100%" }}
                      >
                        Payment
                      </Button>
                    </Grid>
                    <Grid item xs={3} />
                  </Grid>
                  <VerticalSpace />
                </div> */}
                <div className="form__form-group">
                  <p style={{ marginLeft: "auto", marginRight: "auto" }}>
                    {this.state.page === 1 ? ("Click Proceed to Payment to check out.") : ("Click next to add more services or Proceed to Payment to check out.")}
                  </p>
                </div>
                {/* <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={6}>
                      <Button variant="outlined" style={{ width: "100%" }} type="button" disabled={this.state.page === 1} onClick={this.previousPage}>
                        Back</Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button variant="outlined" style={{ width: "100%" }} type="button" onClick={this.nextPage} disabled={this.state.page === 3}>
                        Next</Button>
                    </Grid>
                  </Grid>
                </div> */}
                <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <PaymentButton />
                    </Grid>
                  </Grid>
                  <VerticalSpace />
                </div>
              </form>
              <SimpleBottomNavigation value={1} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "bookappointment_form" // a unique identifier for this form
})(BookAppointment);



// WEBPACK FOOTER //
// ./src/pages/main/BookAppointment.js